export default __webpack_public_path__ + "static/media/ImgTicket01.c0f9dd3e.jpg";